import React, { useEffect, useState } from "react";
import { Button, Modal, Table, Form } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { commaSeperator } from "../../utils/hook";
import { Link } from "react-router-dom";
import DiscountList from "./DiscountList";
import { applyReferralCode, sendOtpMethod } from "../../utils/Api";
import { ToastProvider, useToast } from "../common/RemitAssureToast";
import "../../component/login/login.css";

const ReviewYourTransfer = ({
  data,
  isConfirmation,
  handleCancel,
  handleContinue,
  handleDirectProceed,
}) => {
  const [coupon_selector, setCouponSelector] = useState(false);
  const [user_data, setUserData] = useState(
    JSON.parse(sessionStorage.getItem("remi-user-dt"))
  );
  const [applied, setApplied] = useState(null);
  const [discount_values, setDiscountValues] = useState({
    final_amount: data?.data?.amount?.send_amt || 0,
    discount_amount: data?.data?.amount?.discount_amount || 0,
    total_amount: data?.data?.amount?.send_amt || 0,
  });
const {showToast}=useToast();
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const handleCouponSelector = () => {
    setCouponSelector(!coupon_selector);
  };

  const handleCouponSelection = (value) => {
    applyReferralCode({
      referral_meta_id: value?.referral_meta_id,
      transaction_id: sessionStorage.getItem("transaction_id"),
    }).then((res) => {
      if (res.code === "200") {
        setDiscountValues(res?.data);
        setApplied(value);
      } else {
        showToast('error','Error',res.message);
      }
    });
  };

  const removeDiscount = () => {
    setApplied(null);
    setDiscountValues({
      final_amount: data?.data?.amount?.send_amt || 0,
      discount_amount: data?.data?.amount?.discount_amount || 0,
      total_amount: data?.data?.amount?.send_amt || 0,
    });
    sessionStorage.removeItem("discApp");
  };

  const handleContinueClick = () => {
    if (data?.data?.reason) {
      setShowPasswordPopup(true);
    } else {
      handleContinue();
    }
  };

  const proceedDirectlyToNextStep = () => {
    sessionStorage.setItem("password_verified", "true");

    setShowPasswordPopup(false);
    setPassword("");

    if (handleDirectProceed) {
      handleDirectProceed();
    } else {

      handleDirectPaymentProcessing();
    }
  };

  const handleDirectPaymentProcessing = () => {
    const transferData = JSON.parse(sessionStorage.getItem("transfer_data"));
    const paymentType = transferData?.payment_type || "PayByID";

    if (paymentType === "PayByID") {
      processPayIDDirectly();
    } else if (paymentType === "PayTo") {
      processPayToDirectly();
    } else {
      handleContinue();
    }
  };
  const processPayToDirectly = () => {
    const local = JSON.parse(sessionStorage.getItem("transfer_data"));

    showToast('success','Success',"PayTo agreement processed successfully!");
  };

  const handlePasswordSubmit = async (enteredPassword) => {
    if (!enteredPassword.trim()) {
      showToast('error','Error',"Please enter your password");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        password: enteredPassword,
        mobile: user_data?.mobile,
        method: "login",
        page: "check-password",
      };

      const response = await sendOtpMethod(payload);

      if (response.code === "200") {
        proceedDirectlyToNextStep();
      } else {
        showToast('error','Error',response.message || "Password verification failed");
      }
    } catch (error) {
      showToast('error','Error',"An error occurred while verifying password");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (applied) {
      sessionStorage.setItem(
        "discApp",
        JSON.stringify({
          value: applied,
          tId: sessionStorage.getItem("transaction_id"),
        })
      );
    }
  }, [applied]);

  return (
    <>
      <div
        className="col-md-12 d-grid m-0 p-0"
        style={{ placeItems: "center" }}
      >
        <div className="form-head mb-4">
          <h2 className="text-black font-w600 mb-0">
            <b>
              {!data?.data?.reason
                ? "Review Your Transfer"
                : "Confirm Your Transfer"}
            </b>
          </h2>
        </div>
        <div className="card w-100">
          <div className="card-body">
            <div className="w-100 review_transfer_head">
              <b className="text-start fs-5">Transfer Details</b>
            </div>
            <div className="row my-4">
              <div className="col-md-6">
                <div className="review_transfer_field my-3">
                  <span>Amount Sending</span>
                  <th className="float-end">
                    {data?.data?.amount?.from_type}{" "}
                    {discount_values.total_amount !== "" &&
                      discount_values.total_amount !== undefined &&
                      discount_values.total_amount !== null
                      ? commaSeperator(discount_values.total_amount)
                      : discount_values.total_amount}
                  </th>
                </div>
                <div className="review_transfer_field my-3">
                  <span>Amount Exchanged</span>
                  <th className="float-end">
                    {data?.data?.amount?.to_type}{" "}
                    {data?.data?.amount?.exchange_amt !== "" &&
                      data?.data?.amount?.exchange_amt !== undefined &&
                      data?.data?.amount?.exchange_amt !== null
                      ? commaSeperator(data?.data?.amount?.exchange_amt)
                      : data?.data?.amount?.exchange_amt}
                  </th>
                </div>
                {isConfirmation && (
                  <div className="review_transfer_field my-3 text-success">
                    <span>Discount Applied</span>
                    <th className="float-end">
                      <span className="text-success">
                        {data?.data?.amount?.from_type}{" "}
                        {discount_values?.discount_amount}
                      </span>
                      {applied?.name && (
                        <small>
                          {applied?.name?.toLowerCase() === "invite"
                            ? "(Refferal discount)"
                            : `(${applied?.name} discount)`}
                        </small>
                      )}
                    </th>
                  </div>
                )}
                {isConfirmation && (
                  <div className="row">
                    <div className="col-md-6">
                      {applied === null && (
                        <span
                          style={{ color: "rgba(114, 62, 235, 0.7)" }}
                          onClick={() => handleCouponSelector()}
                        >
                          <b
                            className="mt-2"
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            See All Coupons
                          </b>{" "}
                          &rarr;
                        </span>
                      )}
                    </div>
                    <div className="col-md-6">
                      {applied && (
                        <Button
                          variant="danger"
                          className="float-end"
                          onClick={() => removeDiscount()}
                        >
                          Remove
                        </Button>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <div className="review_transfer_field my-3">
                  <span>Total Cost</span>
                  <th className="float-end">
                    {data?.data?.amount?.from_type}{" "}
                    {commaSeperator(discount_values?.final_amount)}
                  </th>
                </div>
                <div className="review_transfer_field my-3">
                  <span>Total To Recipient</span>
                  <th className="float-end">
                    {data?.data?.amount?.to_type}{" "}
                    {data?.data?.amount?.exchange_amt !== "" &&
                      data?.data?.amount?.exchange_amt !== undefined &&
                      data?.data?.amount?.exchange_amt !== null
                      ? commaSeperator(data?.data?.amount?.exchange_amt)
                      : data?.data?.amount?.exchange_amt}
                  </th>
                </div>
                <div className="review_transfer_field my-3">
                  <span>Exchange Rate</span>
                  <th className="float-end">
                    1 {data?.data?.amount?.from_type} ={" "}
                    {data?.data?.amount?.exchange_rate !== "" &&
                      data?.data?.amount?.exchange_rate !== undefined &&
                      data?.data?.amount?.exchange_rate !== null
                      ? commaSeperator(data?.data?.amount?.exchange_rate)
                      : data?.data?.amount?.exchange_rate}{" "}
                    {data?.data?.amount?.to_type}
                  </th>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="w-100 review_transfer_head">
                  <b className="text-start fs-5">Transfer From </b>
                  <small>{user_data?.account_type === "business"
        ? "(Business Details)"
        : "(Sender Details)"}</small>
                </div>
                <div className="review_transfer_field mt-4">
                  <span>   {user_data?.account_type === "business"
        ? "Business Name"
        : "Sender Name"}</span>
                  <th className="float-end">
                    {user_data?.account_type === "business"
        ? user_data?.business_name
        : `${user_data?.First_name || ""} ${user_data?.Last_name || ""}`}
                  </th>
                </div>
              </div>
              <div className="col-md-6">
                <div className="w-100 review_transfer_head mb-4">
                  <b className="text-start fs-5">Transfer To </b>
                  <small>(Recipient Details)</small>
                </div>
                <div className="review_transfer_field mt-4">
                  <span>Beneficiary Name</span>
                  <th className="float-end">
                    {data?.data?.recipient?.account_type === "business"
                      ? data?.data?.recipient?.business_name
                      : (data?.data?.recipient?.name || "").trim()}
                  </th>
                </div>
                <div
                  className="review_transfer_field my-3 d-flex justify-content-between"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <span>Bank Name</span>
                  <th className="float-end">
                    <p style={{ whiteSpace: "normal" }} className="ms-2">
                      {data?.data?.recipient?.bank_name || ""}
                    </p>
                  </th>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-4">
                <button
                  className="start-form-button"
                  type="button"
                  onClick={() => handleCancel()}
                >
                  Back
                </button>
              </div>
              <div className="col-md-8 full-col">
                <button
                  className="form-button detail_buttoon"
                  type="button"
                  onClick={() => handleContinueClick()}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Password Verification Modal */}
      <Modal
        show={showPasswordPopup}
        onHide={() => {
          setShowPasswordPopup(false);
          setPassword("");
        }}

        centered
        dialogClassName="verify-modal"
      >
        <Modal.Body className="verify-popup text-center pass_model">
          <h4 className="fw-bold">Verify Your Account</h4>
          <p className="text-muted small">
            Please enter your password to confirm and proceed.
          </p>
          {/* Password Input with Eye Toggle */}
          <div className="my-4 position-relative outer_pass">
         <Form.Control
  type={showPassword ? "text" : "password"}
  placeholder="Enter Password..."
  value={password}
  onChange={(e) => setPassword(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      handlePasswordSubmit(password);
    }
  }}
  className="verify-input"
/>
            <span
              className="password-toggle-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          {/* Buttons */}
          <div className="d-flex justify-content-center gap-3 mt-4">
            <Button
              variant="outline-secondary"
              className="verify-cancel"
              onClick={() => {
                setPassword("")
                setShowPasswordPopup(false)}}
            >
              CANCEL
            </Button>
            <Button
              className="otp-btn w-50 d-flex align-items-center justify-content-center"
              onClick={() => handlePasswordSubmit(password)}
              disabled={loading}
            >
              {loading ? "Checking..." : "CONTINUE"}
              {!loading && (
                <img
                  src="https://remitassure.com/assets/img/home/Union.svg"
                  alt="arrow"
                  style={{ width: "18px", height: "18px", marginLeft: "8px" }}
                />
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <DiscountList
        show={coupon_selector}
        handler={() => handleCouponSelector()}
        handleSelected={(value) => handleCouponSelection(value)}
        selected={applied}
        currency={data?.data?.amount?.from_type}
      />
    </>
  );
};

export default ReviewYourTransfer;